import moment from "moment";
import { PeriodEnum } from "@/commons/enums/Period";

const dateFormat = "YYYY-MM-DD";
const dateTimeFormat = "YYYY-MM-DD HH:mm";

export function getDateByPeriodType(periodType: number) {
  if (periodType === PeriodEnum.LAST_MONTH.value) {
    return getLastMonth();
  }
  if (periodType === PeriodEnum.THIS_MONTH.value) {
    return getThisMonth();
  }
  if (periodType === PeriodEnum.LAST_SEVEN_DAYS.value) {
    return getLastSevenDays();
  }
  if (periodType === PeriodEnum.LAST_THIRTY_DAYS.value) {
    return getLastThirtyDays();
  }
  if (periodType === PeriodEnum.LAST_THREE_MONTHS.value) {
    return getLastThreeMonths();
  }
  return getLastMonth();
}

export function getLastMonth() {
  const startDate = moment().add(-1, "months").startOf("month").format(dateFormat);
  const endDate = moment().add(-1, "months").endOf("month").format(dateFormat);

  return { startDate, endDate };
}

export function getThisMonth() {
  const startDate = moment().startOf("month").format(dateFormat);
  const endDate = moment().format(dateFormat);

  return { startDate, endDate };
}

export function getLastSevenDays() {
  const startDate = moment().add(-7, "days").format(dateFormat);
  const endDate = moment().add(-1, "days").format(dateFormat);

  return { startDate, endDate };
}

export function getLastThirtyDays() {
  const startDate = moment().add(-30, "days").format(dateFormat);
  const endDate = moment().add(-1, "days").format(dateFormat);

  return { startDate, endDate };
}

export function getLastThreeMonths() {
  const startDate = moment().add(-1, "days").add(-3, "months").format(dateFormat);
  const endDate = moment().add(-1, "days").format(dateFormat);

  return { startDate, endDate };
}

export function getLastSevenDaysIncludingToday() {
  const startDate = moment().add(-6, "days").format(dateFormat);
  const endDate = moment().format(dateFormat);

  return { startDate, endDate };
}

export function getDateSevenDaysAgo(date: Date | string): string {
  return moment(date).add(-6, "days").format(dateFormat);
}

export function getToday(): string {
  const today = new Date();
  const year = today.getFullYear();
  const month = ("00" + (today.getMonth() + 1)).slice(-2);
  const day = ("00" + today.getDate()).slice(-2);

  return year + "-" + month + "-" + day;
}

export function getTodayMonth(): string {
  const today = new Date();
  return today.getMonth() + 1 + "月";
}

export function getYesterdayMidnight(): string {
  return moment().add(-1, "days").startOf("days").format(dateTimeFormat);
}

// date1 と date2 の期間が month を超えているかを返す関数
export function isDiffOfTwoDateOverTargetMonth(
  date1: string,
  date2: string,
  month: number
): boolean {
  const targetDate1 = moment(date1);
  const targetDate2 = moment(date2);
  return targetDate1.diff(targetDate2, "months") >= month;
}

// date1 と date2 の期間が指定された期間（day）を超えているかを返す関数
export function isDiffOfTwoDateOverTargetDays(
  date1: string,
  date2: string,
  days: number
): boolean {
  const targetDate1 = moment(date1);
  const targetDate2 = moment(date2);
  return targetDate1.diff(targetDate2, "days") >= days;
}

// 開始日付から最大期間がうるう年に含まれるかチェックする
export function isIncludeLeapYearByStartDate(startDate: Date): boolean {
  if (startDate.getMonth() > 1) {
    // 3月以降の場合は翌年がうるう年かどうか確認
    return new Date(startDate.getFullYear() + 1 + "-02-29").getMonth() === 1;
  } else {
    // 1月と2月はその年がうるう年か確認
    return new Date(startDate.getFullYear() + "-02-29").getMonth() === 1;
  }
}

// 指定の日付から指定の日数分過去の日付を返す
export function getDateTargetDaysAgoFromTargetDate(date: Date | string, days: number): string {
  return moment(date).add(-days, "days").format(dateFormat);
}

// selectedDate が targetDate より1日以上後の日付であるかどうかを返す
export function isAfterTargetDate(selectedDate: Date | string, targetDate: Date | string): boolean {
  return moment(targetDate) < moment(selectedDate);
}
